// extracted by mini-css-extract-plugin
export default {"activeMenuItem":"Q_B3Pssf_y86qlFiZ_AB","menuItem":"mRBxnwzO4UimfLyl7nEW"};